const Binding = () => import( /* webpackChunkName: "search" */ '@/Views/Binding');
const BindingSuccess = () => import( /* webpackChunkName: "search" */ '@/Views/BindingSuccess');
const ForgetPassword = () => import( /* webpackChunkName: "search" */ '@/Views/forgetPassword');
const ResetPassword = () => import( /* webpackChunkName: "search" */ '@/Views/resetPassword');
const RetrieveAda = () => import( /* webpackChunkName: "search" */ '@/Views/retrieveAda');
const ModifyPassword = () => import( /* webpackChunkName: "search" */ '@/Views/modifyPassword');
const InformationNotify = () => import( /* webpackChunkName: "search" */ '@/Views/InformationNotify');
const LineBindHome = () => import( /* webpackChunkName: "search" */ '@/Views/LineBinding/index');
const Login = () => import( /* webpackChunkName: "search" */ '@/Views/Login/index');
const LineBindSuccess = () => import( /* webpackChunkName: "search" */ '@/Views/LineBinding/bindSuccess');
const LineBindFail = () => import( /* webpackChunkName: "search" */ '@/Views/LineBinding/bindFail');

export default [{
  path: '/binding',
  name: 'Binding',
  component: Binding
}, {
  path: '/success',
  name: 'BindingSuccess',
  component: BindingSuccess
}, {
  path: '/ResetPassword',
  name: 'ResetPassword',
  component: ResetPassword
}, {
  path: '/forgetPassword',
  name: 'ForgetPassword',
  component: ForgetPassword
}, {
  path: '/retrieveAda',
  name: 'RetrieveAda',
  component: RetrieveAda
}, {
  path: '/modifyPassword',
  name: 'ModifyPassword',
  component: ModifyPassword
}, {
  path: '/informationNotify',
  name: 'InformationNotify',
  component: InformationNotify
}, {
  path: '/lineBinding/index',
  name: 'LineBindHome',
  component: LineBindHome
}, {
  path: '/lineBinding/success',
  name: 'LineBindSuccess',
  component: LineBindSuccess
}, {
  path: '/lineBinding/fail',
  name: 'LineBindFail',
  component: LineBindFail
}, {
  path: '/lineBinding/login',
  name: 'Login',
  component: Login
}]



// WEBPACK FOOTER //
// ./src/router/index.js